export const domRelations = [
  "grandparent",
  "itself_grandparent",
  "parent",
  "itself_parent",
  "itself",
  "siblings",
  "itself_siblings",
  "children",
  "itself_children",
  "descendants",
  "itself_descendants",
] as const;
export type $Relation = (typeof domRelations)[number];
export type $RelationOrSelector = $Relation | string;

export function isDomRelation(relation: string): relation is $Relation {
  return domRelations.includes(relation as $Relation);
}
